import React from "react"
import { merge } from "lodash"
import FormRow from "./FormRow"
import ColorDropdownButton from "./ColorDropdownButton"
import IntlProps from "../../state/helpers/IntlProps"
import { injectIntl } from "react-intl"
import { ShortcutDto } from "../../state/shortcut/Shortcut"
import { actionMessages } from "../messages/messages"
import { SHORTCUT_ACTION_TYPE } from "../../state/shortcut/ShortcutAction"
import "../../dashboard/dashboard.scss"
import InvoiceSelectionComponent from "../../invoice/components/InvoiceSelectionComponent"
import QuoteSelectionComponent from "../../quote/components/QuoteSelectionComponent"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Select from "react-select"
import SelectOptionWrapper from "../../common/rich-text/feature-protection-wrappers/selectOptionWrapper.component"
import {actions} from "./helpers.jsx"


interface Props {
    value: ShortcutDto,
    onChange: (value: React.SetStateAction<ShortcutDto>) => void,
}

const ShortcutActionSettings: React.FC<Props & IntlProps> = ({ value, onChange, intl }) => {

    const onActionChange = (valueReceived) => {
        onChange(merge(value, {
            attributes: {
                actionType: valueReceived.value,
                name: getDefaultLabel(valueReceived.value),
                cloneId: ""
            }
        }))
    }

    const onColorChange = (color: string) => {
        onChange(merge(value, {
            attributes: {
                color
            }
        }))
    }

    const onLabelChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        onChange(merge(value, {
            attributes: {
                name: event.target.value,
            }
        }))
    }

    const onDuplicateIdChange = (cloneId: string, projectId: string) => {
        onChange(merge(value, {
            attributes: {
                cloneId: cloneId,
                projectId: projectId,
            }
        }))
    }

    const getDefaultLabel = (actionType) => {
        if (actionType) {
            return intl.formatMessage(actionMessages[actionType])
        }
        return ""
    }

    const getActionOptions = () => {
        return actions.map(a => {
            return {
                label: <SelectOptionWrapper
                    premium={false}
                    redirectToAccount={true}
                    protectionRule={a.feature ? AppContext.accountFeatureIsEnabled(a.feature) : true}
                >
                    <span>{intl.formatMessage(actionMessages[a.actionName])}</span>
                </SelectOptionWrapper>,
                value: a.actionName,
                disabled: a.feature ? !AppContext.accountFeatureIsEnabled(a.feature) : false
            }
        })
    }

    return (
        <div className="pt-4">
            {/* Action row */}
            <FormRow
                label={intl.formatMessage(actionMessages.shortcutActionHeader)}
                errorMessage={intl.formatMessage(actionMessages.shortcutActionError)}
            >
                <Select
                    placeholder={intl.formatMessage(actionMessages.shortcutActionPlaceholder)}
                    options={getActionOptions()}
                    clearable={false}
                    searchable={false}
                    multi={false}
                    value={value.attributes.actionType || ""}
                    onChange={onActionChange}
                />
            </FormRow>

            <FormRow
                label={intl.formatMessage(actionMessages.shortcutActionLabel)}
            >
                <input
                    maxLength={20}
                    value={value.attributes.name || ""}
                    onChange={onLabelChange}
                    type="text"
                    className="form-control"
                    placeholder={getDefaultLabel(value.attributes.actionType)}

                />
            </FormRow>

            {value.attributes.actionType == SHORTCUT_ACTION_TYPE.CLONE_INVOICE &&
                <FormRow label={intl.formatMessage(actionMessages.shortcutActionInvoicesListLabel)}>
                    <InvoiceSelectionComponent
                        onChange={onDuplicateIdChange}
                        id={value.attributes.cloneId}
                    />
                </FormRow>
            }
            {value.attributes.actionType == SHORTCUT_ACTION_TYPE.CLONE_QUOTE &&
                <FormRow label={intl.formatMessage(actionMessages.shortcutActionQuotesListLabel)}>
                    <QuoteSelectionComponent
                        onChange={onDuplicateIdChange}
                        id={value.attributes.cloneId}
                    />
                </FormRow>
            }

            {/* Color row */}
            <FormRow label={intl.formatMessage(actionMessages.shortcutActionColorLabel)} sm="4">
                <ColorDropdownButton value={value.attributes.color} onChange={onColorChange} />
            </FormRow>

        </div>
    )
}

export default injectIntl(ShortcutActionSettings)



// WEBPACK FOOTER //
// ./src/shortcuts/components/ShortcutActionSettings.tsx